export const highlightSelectedText = (
  textToHightlight: string,
  text: string,
): string => {
  const regex = new RegExp(textToHightlight, "gi");
  text = text.replace(regex, '<span style="color:#3C78FF">$&</span>');
  text = text.replace("&", "&amp;");
  return text;
};
